<ng-container *transloco="let t">
  <footer class="footer-container container-fluid pb-80-67 pt-65-45 d-none d-xxl-flex">
    <div class="container">
      <div class="row">
        <div class="col">
          <h5 class="mb-2">Contact</h5>
          <ul class="list-unstyled">
            <li class="mb-2"><a [routerLink]="[CONTACT_ROUTE]"  class="text-white">{{environment.headquartersName}}</a></li>
            <li class="mb-2"><a href="#"
                                class="text-white">{{environment.headquartersStreet + ', ' +
            environment.headquartersPostalNumber + ' ' + environment.headquartersCity}}</a></li>
            <li class="mb-2"><a href="#" class="text-white">+385 123 456</a></li>
            <li class="mb-2"><a href="#" class="text-white">{{environment.contactMail}}</a></li>
          </ul>
        </div>
        <div class="col">
          <h5 class="mb-2">About</h5>
          <ul class="list-unstyled">
            <li class="mb-2"><a href="#" class="text-white">ABOUT</a></li>
            <li class="mb-2"><a href="#" class="text-white">PRESS</a></li>
            <li class="mb-2"><a href="#" class="text-white">FAQ</a></li>
          </ul>
        </div>
        <div class="col">
          <h5 class="mb-2">News</h5>
          <ul class="list-unstyled">
            <li class="mb-2"><a href="#" class="text-white">Održana XY Utrka Trekking 2023</a></li>
            <li class="mb-2"><a href="#" class="text-white">Održana XY Utrka Trekking 2023</a></li>
            <li class="mb-2"><a href="#" class="text-white">Održana XY Utrka Trekking 2023</a></li>
            <li class="mb-2"><a href="#" class="text-white">Održana XY Utrka Trekking 2023</a></li>
          </ul>
        </div>
        <div class="col">
        </div>
      </div>
    </div>
  </footer>
  <div class="container-fluid copyright text-center text-white">
    <div class="container">
      <small>{{'Copyright © Tracey 2023.('+clientVersion+(FooterComponent.backendVersion ? '-' +
        FooterComponent.backendVersion : '') + ')'}}</small>
    </div>
  </div>
</ng-container>


